<template>

    <div class="nav" v-if="showNavigation">

        <disconnect-bar></disconnect-bar>

        <div class="nav__mobile" v-show="!isDesktop && !isCardTuto">

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isNewslettersActive}"
                    @click="goNewsletters">
                <img class="img__24"
                     :src="`/img/navigation/newsletters-${ isNewslettersActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isNewslettersActive,
                    'text-sSemibold': isNewslettersActive
                }">{{ $t('menu_newsletters') }}</p>
            </button>

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isStatsActive}"
                    @click="goStats">
                <img class="img__24"
                     :src="`/img/navigation/stats-2-${ isStatsActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isStatsActive,
                    'text-sSemibold': isStatsActive
                    }">{{ $t('menu_statistics') }}</p>
            </button>

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isSettingsActive}"
                    @click="goSettings">
                <img class="img__24"
                     :src="`/img/navigation/settings-2-${ isSettingsActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isSettingsActive,
                    'text-sSemibold': isSettingsActive
                }">{{ $t('menu_settings') }}</p>
            </button>
        </div>

        <div class="nav__desktop" v-show="isDesktop">

            <div class="nav__desktop__head">
                <img src="/img/foxy/hero.svg" class="nav__desktop__logo">
            </div>

            <div class="nav__desktop__body">

                <button class="nav__desktop__item"
                        :class="{'nav__desktop__item-active': isNewslettersActive}"
                        @click="goNewsletters">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/newsletters-${ isNewslettersActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isNewslettersActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_newsletters') }}</p>
                </button>

                <button class="nav__desktop__item mt__24"
                        :class="{'nav__desktop__item-active': isStatsActive}"
                        @click="goStats">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/stats-2-${ isStatsActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isStatsActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_statistics') }}</p>
                </button>

                <button class="nav__desktop__item mt__24"
                        :class="{'nav__desktop__item-active': isSettingsActive}"
                        @click="goSettings">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/settings-2-${ isSettingsActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isSettingsActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_settings') }}</p>
                </button>
            </div>

            <div class="nav__desktop__footer">

                <span class="nav__desktop__footer__line" @click="showMailboxes = !showMailboxes">
                    <p class="text-lSemibold color__moon mr__4">{{ $tc('mailbox_to_clean', mailboxes.length) }}</p>
                    <div class="nav__desktop__footer__bubble text-baseMedium color__white"
                         v-show="!showMailboxes">{{ mailboxesCount }}</div>
                    <img src="/img/newsletters-v2/chevron-down-full-grey.svg"
                         class="img__16"
                         :class="{'nav__desktop__footer__arrow-reverse': !showMailboxes}"
                    >
                </span>

                <div class="nav__desktop__footer__mailboxes mt__16" v-show="showMailboxes">

                    <div class="nav__desktop__footer__mailbox mt__16"
                         v-for="mailbox in mailboxes"
                         :class="{'shutdown': mailbox.providerShutdown}"
                         @click="toggleEmail(mailbox.email)">
                        <div class="nav__desktop__footer__mailbox__left">
                            <img src="/img/icons/alert-red.svg" class="img__24" v-if="mailbox.providerShutdown">
                            <lottie-loader :size="24" v-else-if="!mailbox.done"></lottie-loader>
                            <img v-else
                                 :src="`/img/newsletters-v2/checkbox-2-${selectedMailboxes.indexOf(mailbox.email) > -1 ? 'on' : 'off'}.svg`"
                                 class="img__24">
                        </div>
                        <div class="nav__desktop__footer__mailbox__middle" :class="{'shutdown': mailbox.providerShutdown}">
                            <p class="email">{{ mailbox.email }}</p>
                            <p class="infos">
                                {{ $tc('cleaning_nb_mails_to_sort', mailbox.count, {nb_emails: mailbox.count}) }}</p>
                        </div>
                    </div>
                </div>

                <button class="ds__button__medium__border ds__button__tertiary mt__32 text-lSemibold"
                        @click="goAddInbox" v-show="showMailboxes">{{ $t('cleaning_done_add_mailbox_cta') }}
                </button>

            </div>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Tag from '@/modules/tag'

import DisconnectBar from '@/components/DisconnectBar'
import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'cleanfox-navigation',

    components: {
        DisconnectBar,
        LottieLoader
    },

    watch: {
        showNavigation(bool) {
            this.updateIsNavigationOpen(bool)
        },

        '$route'() {
            this.updateShowNavigation()
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'isCardTuto',
            'isConnected',
            'mailboxes',
            'selectedMailboxes'
        ]),

        isNewslettersActive() {
            return this.newslettersUrls.indexOf(this.$route.path) > -1
        },

        isStatsActive() {
            return this.statsUrls.indexOf(this.$route.path) > -1
        },

        isSettingsActive() {
            return /\/settings/.test(this.$route.path)
        },

        showNavigation() {
            return this.isConnected && this.isPathWithNavigation
        },

        mailboxesCount() {
            return Object.values(this.mailboxes).filter(item => item.checked).length
        },

        pathsWithNavigation() {
            return [...this.newslettersUrls, ...this.statsUrls, ...this.settingsUrls]
        }
    },

    data() {
        return {
            newslettersUrls: ['/newsletters', '/my-actions'],
            statsUrls: ['/stats', '/weforest'],
            settingsUrls: ['/settings'],
            isPathWithNavigation: false,
            showMailboxes: true
        }
    },

    mounted() {
        this.updateShowNavigation()
    },


    methods: {

        ...Vuex.mapActions([
            'updateIsNavigationOpen',
            'updateSelectedMailboxes'
        ]),

        goNewsletters() {

            Tag.clickAmplitude(this, 'newsletters')

            this.$router.push({path: '/newsletters'})
                .catch(() => {
                })

        },

        goStats() {

            Tag.clickAmplitude(this, 'stats')

            this.$router.push({path: '/stats'})
                .catch(() => {
                })

        },

        goSettings() {

            Tag.clickAmplitude(this, 'settings')

            this.$router.push({path: '/settings'})
                .catch(() => {
                })

        },

        goAddInbox() {
            Tag.clickGA(this, 'add_mailbox')
            this.$router.push({path: '/add-inbox'})
        },

        toggleEmail(email) {
            Tag.clickGA(this, 'select_mailbox')
            const index = this.selectedMailboxes.indexOf(email)
            let newSelectedMailboxes
            if(index > -1) {
                newSelectedMailboxes = this.selectedMailboxes.filter(item => item !== email)
            } else {
                newSelectedMailboxes = [...this.selectedMailboxes, email]
            }
            this.updateSelectedMailboxes(newSelectedMailboxes)
        },

        updateShowNavigation() {
            this.isPathWithNavigation = !!this.$route.matched.filter(match => this.pathsWithNavigation.some(path => match.regex.test(path))).length
        }
    }

}

</script>

<style lang="scss" scoped>

.nav {


    @media screen and (min-width: $above-tablet-length) {
        display: flex;
        border-right: 1px solid $divider;
        &:lang(ar-sa) {
            border-right: initial;
            border-left: 1px solid $divider;
        }
    }

    &__mobile {
        display: flex;
        flex-direction: row;
        align-items: center;

        &__item {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            padding: 10px;
            background-color: $white;
            color: $stone;
        }

        &__item-active {
            color: $charcoal;
        }
    }

    &__desktop {
        overflow: auto;
        display: flex;
        flex-direction: column;
        width: 320px;

        &__head {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 24px;
        }

        &__body {
            display: flex;
            flex-direction: column;
            padding: 24px 8px;
            flex: 1;
        }

        &__footer {
            padding: 40px 24px;
            background-color: $cultured;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            &__line {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;
            }

            &__bubble {
                padding: 2px 8px;
                border-radius: 100px;
                background-color: $aquamarine;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &__arrow-reverse {
                transform: rotate(180deg);
            }

            &__mailboxes {

            }

            &__mailbox {
                display: flex;
                flex-direction: row;
                align-items: center;
                cursor: pointer;

                &__left {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-right: 8px;

                    &:lang(ar-sa) {
                        padding-right: 0;
                        padding-left: 8px;
                    }
                }

                &__middle {
                    text-align: start;

                    .email {
                        font-size: 17px;
                        font-weight: 600;
                        line-height: 1.41;
                    }

                    .infos {
                        font-size: 15px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.33;
                        letter-spacing: normal;
                        color: $aquamarine;
                    }
                }
            }
        }

        &__logo {
            height: 24px;
        }

        &__item {
            width: 100%;
            display: flex;
            flex-direction: row;
            padding: 16px;
            align-items: center;
            justify-content: flex-start;
            background-color: $white;
            cursor: pointer;
            color: $neutralsMoon;
            border-radius: 8px;

            &__ico {
                width: 24px;
                object-fit: contain;
                margin: 0 16px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 16px;
                }
            }
        }

        &__item-active {
            background-color: rgba(89, 177, 233, 0.08);
            color: $aquamarine;
        }
    }

}

.shutdown {
    cursor: not-allowed;

    .email {
        color: $stone;
    }

    .infos {
        color: $silver;
    }
}

.in-the-shadows {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5)
}

</style>
